import Typography from '@mui/material/Typography'
import React from 'react'

import { UTextProps } from './type'

export const UText = (props: UTextProps) => {
  return <Typography {...props}>{props.children}</Typography>
}
